

/// <reference path="DBMappingEntity.ts" />

// Generated class DBMappingEntityWorker_ManagedObject

class DBMappingEntityWorker_ManagedObject extends DBMappingEntity
{
}
